<script>
	import { isValidDateMDY } from "cando-util";

	export let value;
	export let tabindex = 0;
	export let disabled = false;
	export let handleChange = () => {};
	export let key = "";
	export let itemId = "";

	const handleInputChange = (event) => {
		let input = value;

		if (event.data === "/" || event.inputType === "deleteContentBackward") {
			// only pad the first two elements
			input = input
				.split("/")
				.map((s, i) =>
					i < input.split("/").length - 1
						? s.toString().padStart(2, "0")
						: s.toString(),
				)
				.join("/");
		}

		// Remove non-numeric characters
		input = input.replace(/\D/g, "");

		// Split input into parts
		let month = input.substring(0, 2);
		let day = input.substring(2, 4);
		let year = input.substring(4, 8);

		// Format input into MM/DD/YYYY
		if (year.length > 0) {
			input = `${month}/${day}/${year}`;
		} else if (day.length > 0) {
			input = `${month}/${day}`;
		} else if (month.length > 0) {
			input = `${month}`;
		}

		if (event.data === "/") {
			if (!input.endsWith("/")) {
				input += "/";
			}
		}

		if (isValidDateMDY(input)) {
			input = input
				.split("/")
				.map((s) => (s === "" ? "" : Number(s).toString()))
				.join("/");
		}

		value = input;

		handleChange();
	};
</script>

<div>
	<input
		name="new date input"
		type="text"
		{tabindex}
		bind:value
		on:input={handleInputChange}
		class="input input-bordered"
		autocomplete="off"
		aria-autocomplete="none"
		{disabled}
		{key}
		{itemId}
	/>
</div>
